import favoriteDiagnosis from "dto/favoriteDiagnosis.dto";
import dxInterceptionApi from "services/dxInterception.api";
const favoriteDiagnosisService = {
    getAll(userId: string) {
        return dxInterceptionApi.get<favoriteDiagnosis[]>(
            `/favorite-diagnosis/${userId}`
        );
    },
    update(userId: string, favList: favoriteDiagnosis[]) {
        return dxInterceptionApi.put(`/favorite-diagnosis/${userId}`, favList);
    }
};

export default favoriteDiagnosisService;
